<template>
  <div class="question-view-dialog ">
    <div class="quest">
      <div class="title">
        <vue-mathjax :formula="form.title" :safe="false"/>
      </div>

      <div class="fill-list">
        <vue-mathjax v-if="html" :formula="html" :safe="false"/>
      </div>
    </div>
    <div class="quest-img" v-if="form.img_url || form.imgUrl" @click="$emit('urlToParent', form.img_url || form.imgUrl)">
      <img :src="form.img_url || form.imgUrl" :style="imgStyle" alt="">
    </div>
  </div>
</template>

<script>
import fillSum from '../../../plugins/fill_sum'
import fillSumPlus from '../../../plugins/fill_sum_plus'
import extractOverContent from '../../../plugins/extractOverContent'
import cal from './cal'
let pLeft = 'PARENTHESISLEFT', pRight = 'PARENTHESISRIGHT'

export default {
  props: ['form', 'mode'],
  data() {
    return {
      html: '', 
      imgStyle: null,
      valNum: 0,
      answer_results: {
        id: null,
        student_choices: []
      },
      bodyWidth: 1960,
      recordQuestion: []
    }
  },
  computed: {
    isPC: function() {
      if(this.bodyWidth <= 1080) {
        return true
      }
      return false
    }
  },
  watch: {
    'form.id': {
      handler() {
        this.initData()
      },
      deep: true
    },
  },
  methods: {
    getBodyWidth() {
      let body = document.querySelector('.dialog-preview .body')
      // console.log(body.offsetWidth)

      return body.offsetWidth;
    },
    getChoices() {
      let [first] = this.form.choices.splice(0, 1)

      return first && first.id
    },
    // 计算答案
    calculate(pattern) {
      pattern = pattern.replaceAll('{}', '')
            .replaceAll('[]', '').replaceAll('x', '*')
            .replaceAll('÷', '/').replaceAll('()', 'x')
            .replaceAll('{', '(').replaceAll('}', ')')
            .replaceAll('[', '(').replaceAll(']', ')')
            .replaceAll('()', 'x')
      let [left, right] = pattern.split('=')
      
      // 保留10位有效数字 小数: 9, 负数: 9, 负小数: 8
      let retentionLength = 10
      // console.log(`${left}-(${right})`)

      let rightAnswers = String(cal(`${left}-(${right})`))
      
      // 负数
      if(rightAnswers < 0) {
        if(rightAnswers.length > 10) {
          retentionLength = 9
          // 整数, 小数
          let [zs, xs] = String(rightAnswers).split('.'),
          xsLeng = retentionLength - zs.length
          
          xs = Math.round(('0.' + xs) * (10 ** xsLeng)) / (10 ** xsLeng)
          rightAnswers = -(Math.abs(Number(zs)) + Number(xs))
        }
      } else {
        // 正数
        if(rightAnswers.length > 10) {
          retentionLength = 9
          // 整数, 小数
          let [zs, xs] = String(rightAnswers).split('.'),
          xsLeng = retentionLength - zs.length
          
          xs = Math.round(('0.' + xs) * (10 ** xsLeng)) / (10 ** xsLeng)
          rightAnswers = Number(zs) + Number(xs)
        }
      }

      return rightAnswers
    },
    strConvertDom(data) {
      let regex = /\$\$([^$]*)\$\$|\$([^$]*)\$/g,
      // regex2 = /\\left\((?!\\left\()[\S+\s+]*?\\right\)|\((?!\\left\(|\\right\)|\(|\))[\S\s]*?\)/g,
      // regex2 = /\([^()|^\\left(|^\\right)]*\)/g,
      regex2 = /@(.*?)#/g,
      regex3 = /#{2}(.*?)#{2}/g,
      regex4 = /\|(.*?)\|/g,
      regex5 = /(&amp;){2}(.*?)(&amp;){2}/g,
      regex02 = data.match(regex2),
      regex03 = data.match(regex3),
      regex05 = data.match(regex5),
      regexMap = {
        over: /\$(([^$]*)\\over([^$]*))\$/,
        frac: /\$(([^$]*)\\frac([^$]*))\$/,
        overline: /\$(([^$]*)\\overline([^$]*))\$/,
        dfrac: /\$(([^$]*)\\dfrac([^$]*))\$/,
        overbrace: /\$(([^$]*)\\overbrace([^$]*))\$/,
      }

      this.valNum = 0
      // console.log(data)
      if(regex05) {
        // console.log(regex05)
        regex05.filter(its => {
          let itsCte = its.replaceAll('&amp;&amp;', '')

          if(regex4.test(itsCte)) {
            let [expression] = itsCte.match(regex4),
            content = itsCte.replace(expression, '')
            let {newCte: equation, pattern} = fillSumPlus(content, expression),
            arithmetic = this.calculate(pattern)
            let echoHtml = `<span class="fill-box"><input type="text" data-arithmetic="${arithmetic}" class="fill ordinary arithmetic"/></span>`
            equation = equation.replaceAll('()', echoHtml)
            data = data.replace(its, `<span>${equation}</span>`)
          }
        })
      }

      /// regex04 必须在regex05之后过滤
      let regex04 = data.match(regex4)
      if(regex04) {
        regex04.filter(its => {
          let equation = fillSum(its)
          // console.log(equation)
          let arithmetic = this.calculate(equation)
          let echoHtml = `<span class="fill-box"><input type="text" data-arithmetic="${arithmetic}" class="fill ordinary arithmetic" /></span>`
          equation = equation.replace('/', '÷').replace('*', 'x').replace('()', echoHtml)
          data = data.replace(its, `<span>${equation}</span>`)
          // console.log(data)
        })
      }

      let regex01 = data.match(regex)
      if(regex01) {
        // console.clear()
        // console.log(regex01)
        regex01.filter(its => {
          let frac = its.match(regexMap.frac)
          , overline = its.match(regexMap.overline)
          , overbrace = its.match(regexMap.overbrace)
          , dfrac = its.match(regexMap.dfrac)

          if(dfrac) {
            console.clear()
            console.log(dfrac)
            // 处理數据 判断是否被()括住
            for(let i = 2; i < dfrac.length; i++) {
              // 过滤出@#包裹的内容 将其替换成生僻字 '龘'
              let val = dfrac[i].match(regex2)
              // 在替换之前将 \left(, \right) 转为()
              dfrac[i] = dfrac[i].replaceAll('\\left(', '(').replaceAll('\\right)', ')')

              if(val) {
                console.log(val, '+++++')
                val.filter(its => dfrac[i] = dfrac[i].replace(its, '龘'))
              }
            }

            // otherL, otherR 其他, child 分子, parent 分母
            let [, , otherL, content] = dfrac
            , cte = content.match(/\{([^}]+)\}/g)
            , child = ''
            , parent = ''
            , otherR = content || ''
            console.log(cte)
            if(cte){
              cte.map((its, idx) => {
                let r = its.replace('{', '').replace('}', '')
                if(idx == 0) {
                  child = r
                  content = content.replace(its, '')
                } else {
                  parent = r
                  content = content.replace(its, '')
                }
              })
            }

            if(child != '' && parent != '') {
              otherR = content
            } else if(child != '') {
              let [p, ...o] = content.split('')
              parent = parent || p
              otherR = o.join('')
            } else {
              let [c, p, ...o] = content.split('')
              child = child || c
              parent = parent || p
              otherR = o.join('')
            }

            console.log(otherL, child, parent, otherR)
            let groups = [otherL, child, parent, otherR]

            for(let g = 0; g < groups.length; g++) {
              let val = groups[g].match(/龘/g)
              if(val) {
                  let [prevVal, nextVal] = groups[g].split(val[0])
                  groups[g] = {fill: true, val: val, prevVal, nextVal}
                }
              else groups[g] = {fill: false, val: groups[g]}
            }

            let [l, c, p, r] = groups
            let echoHtml = `
              ${
                l.fill ? `${l.prevVal}<div class="fill-box"><input type="text" class="fill ordinary" /></div>${l.nextVal}` : l.val
              }
              <div class="some-as">
                ${ c.fill ? 
                    `
                    <div class="some-child">
                      <span>${c.prevVal}</span>
                      <div class="fill-box">
                        <input type="text" class="fill numerator">
                      </div>
                      <span>${c.nextVal}</span>
                    </div>
                    ` :
                    c.val.indexOf('<input') > -1 ?
                    `<span class="some-child">${c.val}</span>` :
                    `<span class="denominator">${c.val}</span>` }
                <div class="line"></div>
                ${ p.fill ? 
                    `
                    <div class="some-child">
                      <span>${p.prevVal}</span>
                      <div class="fill-box">
                        <input type="text" class="fill numerator">
                      </div>
                      <span>${p.nextVal}</span>
                    </div>
                    ` :
                    p.val.indexOf('<input') > -1 ?
                    `<span class="some-child">${p.val}</span>` :
                    `<span class="denominator">${p.val}</span>` }
              </div>
              ${
                r.fill ? `${r.prevVal}<div class="fill-box"><input type="text" class="fill ordinary" /></div>${r.nextVal}` : r.val
              }
            `
            data = data.replace(its, echoHtml)
          }

          if(overline) {
            console.log(overline)
            // 处理數据 判断是否被()括住
            for(let i = 2; i < overline.length; i++) {
              let val = overline[i].match(regex2)
              // 在替换之前将 \left(, \right) 转为()
              overline[i] = overline[i].replaceAll('\\left(', '(').replaceAll('\\right)', ')')
              
              console.log(val)
              // if(val) {
              //   let [prevVal, nextVal] = overline[i].split(val[0])
              //   overline[i] = {fill: true, val: val, prevVal, nextVal}
              // }
              // else overline[i] = {fill: false, val: overline[i]}
            }
            
            // otherL, otherR 其他, content 内容
            let [, , otherL, content] = overline
            , cte = content.match(/\{([^}]+)\}/g)
            , c = ''
            , otherR = content || ''
            if(cte){
              cte.map((its, idx) => {
                let r = its.replace('{', '').replace('}', '')
                if(idx == 0) {
                  c = r
                  otherR = otherR.replace(its, '')
                } else {
                  otherR = otherR.replace(its, r)
                }
              })
            } else {
              let [f, ...o] = content.split('')
              c = f || ''
              otherR = o.join('')
            }
            console.log(otherR)
            let echoHtml = `
              <div class="overline">
                <span>${otherL}</span>
                <div class="overline-content">${c}</div>
                <span>${otherR}</span>
              </div>
            `
            data = data.replace(its, echoHtml)
          }

          let over = its.match(regexMap.over)
          if(over && !overline && !overbrace) {
            console.log(over)
            // 取出匹配的字符 在进一步过滤
            let newOver = extractOverContent(over[1])
            , to_filter = /{([^{}]*)}/
            , overs = []
            console.log(newOver)
            if(newOver.length != 0) {
              let grade = newOver[0].split('\\over')
              overs = over[1].split(`{${newOver[0]}}`)
              for(let i = grade.length - 1; i >= 0; i--) {
                let otem = grade[i]
                , matchRes = otem.match(to_filter)
                if(matchRes) {
                  otem = otem.replace(matchRes[0], matchRes[1])
                } 
                overs.splice(1, 0, otem)
              }
              console.log('newOver.length != 0')
            } else {
              newOver = over[1].match(to_filter)
              // 判断是否包含\over
              if(newOver && newOver[0].indexOf('\\over') > 0) {
                if(newOver) {
                  overs = over[1].split(newOver[0])
                  overs.splice(1, 0, ...newOver[1].split('\\over'))
                } else {
                  overs = ['', ...over[1].split('\\over'), '']
                }
              } else {
                console.log(over)
                overs = ['']
                for(let i = 2; i < over.length; i++) {
                  let otem = over[i]
                  , matchRes = otem.match(to_filter)
                  if(matchRes) {
                    otem = otem.replace(matchRes[0], matchRes[1])
                  } 
                  overs.push(otem)
                }
              }
            }
            
            console.log(overs)
            // 处理數据 判断是否被()括住
            for(let i = 0; i < overs.length; i++) {
              let val = overs[i].match(regex2)
              // 在替换之前将 \left(, \right) 转为()
              overs[i] = overs[i].replaceAll('\\left(', '(').replaceAll('\\right)', ')')

              if(val) {
                  let [prevVal, nextVal] = overs[i].split(val[0])
                  overs[i] = {fill: true, val: val, prevVal, nextVal}
                }
              else overs[i] = {fill: false, val: overs[i]}
            }
            
            // child 分子, parent 分母
            let [left, child, parent, right] = overs

            let echoHtml = `
            ${
              left.fill ? `<span class="fill-box"><input type="text" class="fill ordinary" /></span>` : left.val
            }
            <span class="some-as">
              ${ child.fill ? 
                  `
                  <span class="some-child">
                    <span>${child.prevVal}</span>
                    <span class="fill-box">
                      <input type="text" class="fill numerator">
                    </span>
                    <span>${child.nextVal}</span>
                  </span>
                  ` :
                  child.val.indexOf('<input') > -1 ?
                  `<span class="some-child">${child.val}</span>` :
                  `<span class="denominator">${child.val}</span>` }
                <span class="line"></span>
              ${ parent.fill ? 
                  `
                  <span class="some-child">
                    <span>${parent.prevVal}</span>
                    <span class="fill-box">
                      <input type="text" class="fill numerator">
                    </span>
                    <span>${parent.nextVal}</span>
                  </span>
                  ` :
                  parent.val.indexOf('<input') > -1 ?
                  `<span class="some-child">${parent.val}</span>` :
                  `<span class="denominator">${parent.val}</span>`}
            </span>
            ${
              (right && right.fill) ? `<span class="fill-box"><input type="text" class="fill ordinary" /></span>` : (right ? right.val : '')
            }
            `
            data = data.replace(its, echoHtml)
          }

          if(frac) {
            // integer 整数部分，fraction 分数部分
            let [, , integer, fraction] = frac
            , fractionRegex = /\{.*?\}/g
            // 取出同时去除首尾的大括号
            , [child, parent] = fraction.match(fractionRegex)
                              .map(s => s.slice(1, -1))
            , other = fraction.replace(`{${child}}{${parent}}`, '')
            let echoData = [integer, child, parent, other]
            // 处理數据 判断是否被()括住
            for(let i = 0; i < echoData.length; i++) {
              let val = echoData[i].match(regex2)
              // 在替换之前将 \left(, \right) 转为()
              echoData[i] = echoData[i].replaceAll('\\left(', '(').replaceAll('\\right)', ')')
              
              if(val) {
                let [prevVal, nextVal] = echoData[i].split(val[0])
                echoData[i] = {fill: true, val: val, prevVal, nextVal}
              } else echoData[i] = {fill: false, val: echoData[i]}
            }

            let echoHtml = `
            <span class="mixed-number">
              ${ echoData[0].fill ? 
                  `
                  <span class="some-child">
                    <span>${echoData[0].prevVal}</span>
                    <span class="fill-box">
                      <input type="text" class="fill mixed">
                    </span>
                    <span>${echoData[0].nextVal}</span>
                  </span>
                  `:
                  echoData[0].val.indexOf('<input') > -1 ?
                  `<span class="some-child">${echoData[0].val}</span>` :
                  `<span class="mixed">${echoData[0].val}</span>` }
              <span class="some-as">
                ${ echoData[1].fill ? 
                  `
                  <span class="some-child">
                    <span>${echoData[1].prevVal}</span>
                    <span class="fill-box">
                      <input type="text" class="fill numerator">
                    </span>
                    <span>${echoData[1].nextVal}</span>
                  </span>
                  `:
                  echoData[1].val.indexOf('<input') > -1 ?
                  `<span class="some-child">${echoData[1].val}</span>` :
                  `<span class="numerator">${echoData[1].val}</span>`}
                <span class="line"></span>
                ${ echoData[2].fill ? 
                  `
                  <span class="some-child">
                    <span>${echoData[2].prevVal}</span>
                    <span class="fill-box">
                      <input type="text" class="fill denominator">
                    </span>
                    <span>${echoData[2].nextVal}</span>
                  </span>
                  ` :

                  echoData[2].val.indexOf('<input') > -1 ?
                  `<span class="some-child">${echoData[2].val}</span>` :
                  `<span class="numerator">${echoData[2].val}</span>`  }
              </span>
            </span>
            ${
              echoData[3].fill ? `<span class="fill-box"><input type="text" class="fill ordinary" /></span>` : echoData[3].val
            }
            `
            data = data.replace(its, echoHtml)
          }
        })

      }
      
      if(regex02) {
        // console.log(regex02)
        regex02.filter(its => {
          // console.log(its)
          let echoHtml = `<span class="fill-box"><input type="text" oninput="fillingBlanks(event)" class="fill ordinary" /></span>`
          // console.log(echoHtml)
          data = data.replace(its, echoHtml)
          this.valNum ++
        })
      } 

      if(regex03) {
        regex03.filter(its => {
          let val = its.replace(/##/g, '')
          let echoHtml = `<span class="fill-box"><span class="fill-not ordinary" value="">${val}</span></span>`
          data = data.replace(its, echoHtml)
        })
      }

      return data.replaceAll(pLeft, '(').replaceAll(pRight, ')')
    },
    initData() {
      this.answer_results = {
        id: null,
        student_choices: []
      }
      this.recordQuestion = []
      
      let content = JSON.parse(this.form.content)
      // console.log(content)
      this.html = this.strConvertDom(content.topic)

      if(this.mode == 'viewAnswer') setTimeout(() => this.showTrueFalse(), 500)

      let t = null
      window.fillingBlanks = () => {
        if(t != null) {
          clearTimeout(t)
          t == null
        }

        t = setTimeout(() => {
          let vals = document.querySelectorAll('.fill'),
          valNum = 0, student_choices = []

          for(let i = 0; i < vals.length; i++) {
            let input = vals[i],
            value = input.value,
            choice_id = Number(input.dataset.id)
            
            if(value.trim() != '') {
              student_choices.push({choice_id, value})
              valNum++
            }
          }
          this.answer_results.student_choices = student_choices
          this.recordQuestion = student_choices
          // console.log(valNum, this.valNum)
          if(valNum >= 1) this.$emit('permissions', true)
          else this.$emit('permissions', false)
        }, 500)
      }
    }
  },
  created() {
    this.initData()
  },
  mounted() {
    this.bodyWidth = this.getBodyWidth()
    window.onresize = () => {
      this.bodyWidth = this.getBodyWidth()
      // console.log(this.bodyWidth)
    } 
    
    this.$nextTick(() => {
      /// arithmetic 算法填空题
      let arithmetic = document.querySelectorAll('.question-view-dialog  .arithmetic'),
      vals = document.querySelectorAll('.dialog-preview .fill'),
      {answers} = this.form
      console.log(answers)
      /// answers前面都是算术答案 
      for(let i = 0; i < arithmetic.length; i++) {
        let input = arithmetic[i]
        input.value = input.dataset.arithmetic || ''
        input.parentNode.classList.add('determine-success-br')
      }
      
      /// answers已经添加完成 在这个基础上循环
      for(let i = arithmetic.length; i < vals.length; i++) {
        let input = vals[i]
        console.log(input)
        /// 过滤算术节点
        if(input.classList.contains('arithmetic')) {
          continue
        }
        // 存在答案 定值直接赋予
        input.value = answers[i].value.replaceAll(pLeft, '\\left(').replaceAll(pRight, '\\right)')

        input.parentNode.classList.add('determine-success-br')
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.question-view-dialog {
  width: 100%;
  height: fit-content !important;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-color: #fff !important;
  // border-radius: 10px;
  .quest {
    // width: calc(55% - 10px);
    flex: 1;
    height: 100%;

    .title {
      font-size: 18px;
      color: #333;
    }

    .fill-list {
      width: 100%;
      margin-top: 20px;

      .single {
        height: fit-content;
        display: inline-block;
        margin-bottom: 5px;
        
        .label {
          // width: 40px;
        }
        
        .val {
          width: 100px;
          height: 40px;
          border-radius: 10px;

          input[type="text"] {
            width: 100%;
            height: 100%;
            text-align: center;
            padding: 5px;
            box-sizing: border-box;
            font-size: 14px;
            font-weight: 700;
            border-radius: 10px;
            background-color: #fcd2ab;
            border: none;
            outline: none;
            box-sizing: border-box;
          }
        }

        .over {
          width: 100px;
          height: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #ffcca4;
          border-radius: 10px;
          .mixed {
            width: 40px;
            height: 40px;
            background-color: #ffcca4;
            padding: 0;
          }
          .mixed-empty {
            width: 1px;
            height: 40px;
            background-color: #ffcca4;
            padding: 0;
            cursor: default;
            border: none;
          }

          .fraction {
            height: 100%;
            width: 45px;
            display: flex;
            flex-wrap: wrap;
            align-content: space-between;
            position: relative;

            .fraction-line {
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              margin: auto;
              background-color: #333;
              width: 80%;
              height: 2px;
            }
            .numerator, .denominator {
              text-align: center;
              width: 100%;
              height: 45%;
              background-color: #ffcca4;
              border-radius: 3px;
              padding: 0;
            }
          }
        }
      }
    }
  }

  .quest-img {
    width: 40%;
    max-width: 500px;
    max-height: 500px;
    // flex: 1;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    aspect-ratio: 833/500;

    img {
      width: 100%;
      height: auto;
      border-radius: 5px;
    }
  }
}
</style>

<style lang="scss">
.question-view-dialog {

  .ordinary {
    color: #333;
    // margin: 5px 0;
  }
  .ordinary.fill, .fill-not {
    border-radius: 10px;
    background-color: #fcd2ab;
    outline: none;
    border: none;
    width: 100px;
    height: 40px;
    text-align: center;
    padding: 5px;
    box-sizing: border-box;
    display: inline-block;
    font-size: 16px;
    // margin-bottom: 5px;
  }
  .fill-box {
    display: inline-block;
    border-radius: 10px;
    margin: 5px 0;
  }

  .overline {
    display: flex;
    align-items: center;
    margin-top: 5px;

    .overline-content {
      position: relative;

      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background-color: #333;
      }
    }
  }

  .some-as {
    display: inline-block;
    // min-width: 100px;
    // display: flex;
    flex-wrap: wrap;
    margin: 0 5px;
    position: relative;
    color: #333;
    vertical-align: middle;
  
    .some-child {
      display: inline-block;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 50px;
    }

    .line {
      width: inherit;
      min-width: 30px;
      height: 1px;
      background-color: #333;
      display: block;
    }

    .numerator, .denominator {
      // margin: 5px 0;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 50px;
    }
  
    .numerator.fill, .denominator.fill {
      border-radius: 10px;
      background-color: #fcd2ab;
      outline: none;
      border: none;
      height: 40px;
      width: 100px;
      text-align: center;
      padding: 5px;
      box-sizing: border-box;
    }
  }
  
  .mixed-number {
    display: inline-flex;
    align-items: center;
    .mixed {
      color: #333;
    }
  
    .mixed.fill {
      border-radius: 10px;
      background-color: #fcd2ab;
      outline: none;
      border: none;
      width: 100px;
      height: 40px;
      text-align: center;
      padding: 5px;
      color: #333;
    }
  }
}
</style>